import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReportService} from '~/app/core/reports/services/report.service';
import {Observable,lastValueFrom} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserService} from '~/app/core/services/user.service';
import {ToastService} from '~/app/core/services/toast-service';
import {FSInvoiceDialogService} from "~/app/core/services/fsinvoice.dialog.service";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-reports-extract',
  templateUrl: './reports-extract.component.html',
  styleUrls: ['./reports-extract.component.scss'],
})
export class ReportsExtractComponent implements OnInit {


  constructor(public reportsService: ReportService, public userService: UserService, public toastService: ToastService,
              public loadingService: LoadingIndicatorHelper, public fsInvoiceDialog: FSInvoiceDialogService) {
  }

  public savedExtractsList: any;
  extractFields: any[];
  fieldsSelected: any = [];
  dataItem: any = null;
  extractsMasterList: any[];
  multiple: any;
  fieldsSelectedSelectedGrid: any = [];
  @Input('value')
  public value: any[] = [];
  @Input() public currentSavedFields: any = [];
  @Output() currentSavedFieldsChange = new EventEmitter<number>();
  @Input() private _fields: Observable<any[]>;
  @Input() hoId: string;
  @Input() reportId: string;
  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  async ngOnInit() {
    if (this.reportId != null && this.hoId != null) {
      this.loadingService.show();
      await lastValueFrom(this.reportsService.getAllExtractFields(this.hoId, this.reportId)).then((results) => {
        this.extractsMasterList = results;
        this.extractFields = [...this.extractsMasterList];
      }).catch(() => {
      }).finally(() => {
        this.loadingService.hide();
      });
      this.setExtractLists();
    }

  }

  loadReportField($event: any) {
    this.dataItem = $event;
    if ($event == null) {
      this.currentSavedFields = [];
      return;
    }
    this.loadingService.show();
    lastValueFrom(this.reportsService.getSavedExtractFields(this.hoId, this.reportId, $event.id)).then(async (results) => {
      if (this.extractsMasterList == null || this.extractsMasterList.length === 0) {
        this.extractFields = [];
        this.currentSavedFields = results;
        return;
      }

      if (results != null) {
        this.extractFields = [];
      }
      const fields = await this.filterArray(this.extractsMasterList, results);
      this.extractFields = fields;
      this.currentSavedFields = results;
    }).catch().finally(() => {
      this.loadingService.hide();
      this.currentSavedFieldsChange.emit(this.currentSavedFields);
    });
  }

  reorderFields($event: any) {
    this.currentSavedFields = this.currentSavedFields.sort((a, b) => a.fieldOrder - b.fieldOrder);
  }

  async filterArray(mainArray: any[], filterArray: any[]) {
    const temp = [];
    await mainArray.forEach((item) => {
      const searchedItem = filterArray.find((internalItem) => internalItem.fieldName === item.fieldName);
      if (searchedItem == null) {
        temp.push(item);
      }
    });
    return temp;
  }

  moveButtonClicked($event: any) {
    this.fieldsSelected.forEach((field) => {
      const getObject = this.extractFields.find((tempfield) => tempfield.fieldName === field);
      if (this.currentSavedFields.length === 0) {
        getObject.fieldOrder = 1;
      } else {
        const fieldOrder = this.currentSavedFields[this.currentSavedFields.length - 1].fieldOrder;
        getObject.fieldOrder = fieldOrder + 1;
      }
      this.currentSavedFields.push(getObject);
      const obj = this.extractFields.findIndex(store => store.fieldName === field);
      this.extractFields.splice(obj, 1);
    });
    this.fieldsSelected = [];
    this.reorderFields(null);
    this.currentSavedFieldsChange.emit(this.currentSavedFields);
  }

  public valueNormalizer = (text: Observable<string>) => text.pipe(map((content: string) => {
    return {
      id: 99999,
      name: content,
      userId: this.userService.getUserName().toUpperCase(),
      lastUsed: Date.now()
    };
  }))


  setExtractLists() {
    lastValueFrom(this.reportsService.getSavedExtractList(this.hoId, this.reportId)).then((results) => {
      this.savedExtractsList = results;
      if (this.savedExtractsList != null && this.savedExtractsList.length > 0) {
        this.dataItem = this.savedExtractsList[0];
      }

      this.loadReportField(this.dataItem);
      this.currentSavedFieldsChange.emit(this.currentSavedFields);
      console.log(this.savedExtractsList);
    });
  }

  public checkDuplicateFieldIds() {
    const mapObject = this.currentSavedFields.map((field) => {
      return field.fieldOrder;
    });
    return this.hasDuplicates(mapObject);
  }

  public hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

  public async saveExtractList() {
    if (this.checkDuplicateFieldIds()) {
      this.toastService.showErrorToast('Please update your field order, duplicates can not exist', 'Error');
      return;
    }
    this.loadingService.show();
    if (this.dataItem.id === 99999) {
      await lastValueFrom(this.reportsService.postNewExtract(this.hoId, this.reportId, this.userService.getUserName().toUpperCase(),
        this.dataItem.name, this.currentSavedFields)).then((response) => {
        if (response.ok) {
          this.setExtractLists();
          this.toastService.showSuccessToast('Extract Added Successfully', 'Added');
        }
      }).catch((error) => {
        this.toastService.showErrorToast('Problem Adding extract', 'Error');
      }).finally(() => {
        this.loadingService.hide();
      });


    } else {
      await this.reportsService.updateExtract(this.hoId, this.reportId, this.userService.getUserName().toUpperCase(),
        this.dataItem.name, this.dataItem.id, this.currentSavedFields).toPromise().then((response) => {
        if (response.ok) {
          this.setExtractLists();
          this.toastService.showSuccessToast('Extract Saved Successfully', 'Saved');
        }
      }).catch((error) => {
        console.log("Error")
        this.toastService.showErrorToast('Problem saving extract', 'Error');
      }).finally(() => {
        this.loadingService.hide();
      });

    }
  }

  public async deleteExtractItem() {
    this.fsInvoiceDialog.showBetterYesNoDialog('Delete', 'Delete this saved extract?').toPromise().then(async (result) => {
      if (!result) {
        return;
      }
      const itemExtract = this.savedExtractsList.find((item) => item.id === this.dataItem.id);
      if (itemExtract == null) {
        this.setExtractLists();
        this.toastService.showSuccessToast('Extract Deleted Successfully', 'Deleted');
        return;
      }

      this.loadingService.show();

      await this.reportsService.deleteExtract(this.hoId, this.reportId, itemExtract.name).toPromise().then((response) => {
        if (response.ok) {
          const obj = this.savedExtractsList.indexOf(itemExtract);
          this.savedExtractsList.splice(obj, 1);
          this.setExtractLists();
          this.toastService.showSuccessToast('Extract Deleted Successfully', 'Deleted');
        } else {
          console.log('Error Deleting');
        }
      }).catch(() => {
        this.toastService.showErrorToast('Problem deleting extract', 'Error');
      }).finally(() => {
        this.loadingService.hide();
      });
      this.currentSavedFieldsChange.emit(this.currentSavedFields);
    }).catch().finally();
  }

  moveAllButtonClicked($event: any) {
    console.log(this.fieldsSelected);
    for (let i = this.extractFields.length - 1; i >= 0; i--) {
      const getObject = this.extractFields[i];
      if (this.currentSavedFields.length === 0) {
        getObject.fieldOrder = 1;
      } else {
        const fieldOrder = this.currentSavedFields[this.currentSavedFields.length - 1].fieldOrder;
        getObject.fieldOrder = fieldOrder + 1;
      }

      this.currentSavedFields.push(getObject);
      this.extractFields.splice(i, 1);
    }
    this.fieldsSelected = [];
    this.reorderFields(null);
    this.currentSavedFieldsChange.emit(this.currentSavedFields);
  }

  removeButtonClicked($event: any) {
    console.log(this.fieldsSelectedSelectedGrid);
    this.fieldsSelectedSelectedGrid.forEach((field) => {
      const getObject = this.currentSavedFields.find((tempfield) => tempfield.fieldName === field);
      this.extractFields.push(getObject);
      const obj = this.currentSavedFields.findIndex(stor => stor.fieldName === field);
      this.currentSavedFields.splice(obj, 1);
    });
    this.fieldsSelected = [];
    this.fieldsSelectedSelectedGrid = [];
    this.reorderFields(null);
    this.currentSavedFieldsChange.emit(this.currentSavedFields);
  }

  removeAllButtonClicked($event: any) {
    console.log(this.fieldsSelected);
    for (let i = this.currentSavedFields.length - 1; i >= 0; i--) {
      const getObject = this.currentSavedFields[i];
      this.extractFields.push(getObject);
      this.currentSavedFields.splice(i, 1);
    }
    this.fieldsSelected = [];
    this.fieldsSelectedSelectedGrid = [];
    this.reorderFields(null);
    this.currentSavedFieldsChange.emit(this.currentSavedFields);
  }


  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(val: any): void {
    if (val) {
      this.value = val;
    }
  }

  keyChangeMove(event) {
    this.fieldsSelected = event
  }

  keyChangeRemove(event) {
    this.fieldsSelectedSelectedGrid = event
  }
}
